const LINKS = {
  URL_BAZAARVOICE: `https://apps.bazaarvoice.com/deployments/${process.env.GATSBY_BAZAARVOICE_CLIENT_NAME}/${process.env.GATSBY_BAZAARVOICE_SITE_ID}/${process.env.GATSBY_BAZAARVOICE_ENVIRONMENT}/${process.env.GATSBY_BAZAARVOICE_LOCALE}/bv.js`,
};

export default LINKS;
